/* eslint max-len: 0 */

export default function getStyles(styles, rect) {
   let innerWidthWRPl = `calc(100% - ${styles.rplaylistHeight})`;
   let wrapperWidthR = styles.rplaylistHeight;

   if (rect) {
      const w = rect.right - rect.left;
      innerWidthWRPl = w * 0.7 + 'px';
      wrapperWidthR = w * 0.3 + 'px';
   }

   return `

.rplayer--fullscreen .rplayer--right-playlist .rplayer__playlist-wrapper {
   max-height: calc(100vh - 44px);
   width: 0;
}

.rplayer--right-playlist .rplayer__playlist-wrapper {
   width: ${wrapperWidthR};
   float: right;
   height: 100%;
}

.rplayer--right-playlist .rplayer__playlist {
   background-color: #424242;
   overflow-y: auto;
   overflow-x: hidden;
   position: absolute;
   top: 78px;
   bottom: 0;
   left: 0;
   right: 0;
}

.rplayer--right-playlist .rplayer__playlist-wrapper.rplayer__playlist-wrapper--wot-title .rplayer__playlist {
   top: 22px;
}

.rplayer--right-playlist .rplayer__playlist-header {
   max-height: 56px;
   display: -webkit-box;
   -webkit-box-orient: vertical;
   text-overflow: ellipsis;
   -webkit-line-clamp: 2;
}

.rplayer--right-playlist .rplayer__inner {
   width: ${innerWidthWRPl};
   float: left;
}

.rplayer--right-playlist .rplayer__playlist-item {
   padding: 8px;
   height: 70px;
   border-top: 1px solid #000;
}

.rplayer--right-playlist .rplayer__playlist-item-title {
   font-size: 13px;
   line-height: 1.4;
   height: 52px;
   display: block;
   overflow: hidden;
   display: -webkit-box;
   -webkit-box-orient: vertical;
   text-overflow: ellipsis;
   -webkit-line-clamp: 3;
}

.rplayer--right-playlist .rplayer__playlist-item-thumb {
   margin-right: 6px;
   width: 96px;
   height: 54px;
   float: left;
}

.rplayer--right-playlist .rplayer__playlist-item--current .rplayer__playlist-item-thumb:before {
   font-size: 28px;
   line-height: 54px;
}

.rplayer--right-playlist .rplayer__playlist-of {
   left: 8px;
   top: 58px;
}

.rplayer--right-playlist .rplayer__playlist-wrapper.rplayer__playlist-wrapper--wot-title .rplayer__playlist-of {
   top: 5px;
}

.rplayer--right-playlist .rplayer__playlist-left-btn, .rplayer--right-playlist .rplayer__playlist-right-btn {
   display: none !important;
}

   `;
}
